import React from 'react';
import { useGlobalContext } from './context';

const Search = () => {
const {query,searchPost} = useGlobalContext();
  return (
    <>
    <h1>Naman's Technical Website</h1>
    <form onSubmit={(e)=>e.preventDefault()}>
      <div className='search_box123'>
        <input type="text" placeholder='Search here' 
        value={query}
        onChange={(e)=>searchPost(e.target.value)}
        />
      </div>
    </form>
    </>
  )
};

export default Search;
